import React from 'react';
import styled from 'styled-components';
import useLocationQuery from '../../../hooks/useQuery';
import { ReactComponent as NotFilteredSvg } from '../../../resources/pharmacy_filter.svg';
import { ReactComponent as FilteredSvg } from '../../../resources/pharmacy_filter_green.svg';
import { isFilteredByPharmacy } from '../helpers';

const PharmacyFilter = ({ isPharmacyFilterVisible, pharmacyId }) => {
  const { query, changeLocationQuery } = useLocationQuery();
  const pharmacyIdInQuery = query.pharmacy_id;

  const pharmacyFilterClickHandler = () => {
    if (isFilteredByPharmacy(query)) {
      const { pharmacy_id, ...newQuery } = query;
      changeLocationQuery({
        ...newQuery,
        page: 0,
      });
    } else {
      changeLocationQuery({
        ...query,
        page: 0,
        pharmacy_id: pharmacyId,
      });
    }
  };

  return (
    <FilterWrapper
      onClick={pharmacyFilterClickHandler}
      isPharmacyFilterVisible={isPharmacyFilterVisible}
    >
      {pharmacyIdInQuery ? <FilteredSvg /> : <NotFilteredSvg />}
    </FilterWrapper>
  );
};

const FilterWrapper = styled.div`
  opacity: ${(props) => (props.isPharmacyFilterVisible ? 1 : 0)};
`;

export default PharmacyFilter;
